import React from 'react';
import { FileCheck2, Mail, Phone, MapPin, Linkedin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-white/10 bg-primary text-white">
      <div className="w-4/5 mx-auto flex flex-col items-center justify-between gap-6 px-8 py-10 md:flex-row md:py-0">
        <div className="flex flex-col items-center gap-4 md:flex-row md:gap-3 group">
          <div className="text-accent group-hover:text-accent-hover transition-colors">
            <FileCheck2 className="h-6 w-6" />
          </div>
          <p className="text-center text-sm leading-loose text-slate-400 md:text-left">
            © 2025 Verifiko. Wszelkie prawa zastrzeżone.
          </p>
        </div>
        <div className="flex flex-col items-center gap-4 text-sm font-medium md:flex-row md:gap-8">
          <a href="/krs/" className="text-slate-400 hover:text-accent transition-colors">Katalog Firm i Fundacji</a>
          <a href="/cennik" className="text-slate-400 hover:text-accent transition-colors">Cennik</a>
          <a href="/przewodnik-po-reprezentacji-spolek-w-polsce" className="text-slate-400 hover:text-accent transition-colors">Poradnik</a>
        </div>
        <div className="flex flex-col items-center gap-2 text-sm text-slate-400 md:items-end md:gap-2 py-6">
          <div className="flex items-center gap-2 hover:text-accent transition-colors">
            <Linkedin className="h-4 w-4" />
            <a href="https://www.linkedin.com/company/verifiko/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
          <div className="flex items-center gap-2 hover:text-accent transition-colors">
            <Mail className="h-4 w-4" />
            <a href="mailto:kontakt@verifiko.pl">kontakt@verifiko.pl</a>
          </div>
          <div className="flex items-center gap-2 hover:text-accent transition-colors">
            <Phone className="h-4 w-4" />
            <a href="tel:+48518929623">+48 518 929 623</a>
          </div>
          <div className="flex items-center gap-2 hover:text-accent transition-colors">
            <MapPin className="h-4 w-4" />
            <span>ul. Sienkiewicza 99/2, 50-335 Wrocław</span>
          </div>
          <p className="text-sm text-slate-500 mt-1">
            Właścicielem Verifiko jest MAESTRIA Janusz Pastuszak
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;